export default [
  {
    query: 'ibuprofen',
    suggestions: ['400', '600', 'kinder', 'zäpfchen', '400 akut'],
  },
  {
    query: 'magnesium',
    suggestions: ['Verla', 'Diasporal', '400', 'Direkt', 'Magnesiumcitrat'],
  },
  {
    query: 'Wick',
    suggestions: ['Medinait', 'Daynait', 'zzzquil', 'vaporub', ' husten'],
  },
  {
    query: 'la roche posay',
    suggestions: [
      'Effaclar',
      'Anthelios',
      'Sonnenschutz',
      'Toleriane',
      'Lipikar',
    ],
  },
  {
    query: 'eucerin',
    suggestions: [
      'dermopure',
      'hyaluron',
      'atopicontrol',
      'anti pigment',
      'urearepair',
    ],
  },
  {
    query: 'vitamin d',
    suggestions: ['d3', '2000', 'k2', 'loges', 'kinder'],
  },
  {
    query: 'augentropfen',
    suggestions: [
      'trockene augen',
      'allergie',
      'hylo',
      'bindehautentzündung',
      'hyaluron',
    ],
  },
  {
    query: 'hustensaft',
    suggestions: ['kinder', 'baby', 'prospan', 'erwachsene', 'pflanzlich'],
  },
  {
    query: 'zink',
    suggestions: [
      'zinksalbe',
      'zinkorotat',
      'zinkletten',
      'verla',
      'tabletten',
    ],
  },
  {
    query: 'erkältung',
    suggestions: [
      'erkältungssalbe',
      'erkältungsbad',
      'erkältungsbalsam',
      'erkältungstee',
      'kinder',
    ],
  },
  {
    query: 'vichy',
    suggestions: [
      'deodorant',
      'normaderm',
      'liftactiv',
      'neovadiol',
      'dermablend',
    ],
  },
  {
    query: 'Avéne',
    suggestions: [
      'Sonnencreme',
      'Cleanance',
      'Tolerance',
      'Antirougeurs',
      'Hydrance',
    ],
  },
  {
    query: 'Nagelpilz',
    suggestions: ['lack', 'creme', 'nagellack', 'canesten', 'ciclopoli'],
  },
  {
    query: 'orthomol',
    suggestions: ['immun', 'vital f', 'junior', 'natal', 'vital m'],
  },
  {
    query: 'Vitamin c',
    suggestions: ['serum', '1000', 'pulver', 'zink', 'hochdosiert'],
  },
  {
    query: 'vitamin c',
    suggestions: ['serum', '1000', 'pulver', 'pure', 'brausetabletten'],
  },
  {
    query: 'eisen',
    suggestions: [
      'eisentabletten',
      'verla',
      'eisenmangel',
      'eisensaft',
      'kinder',
    ],
  },
  {
    query: 'husten',
    suggestions: [
      'hustensaft',
      'hustenstiller',
      'hustenlöser',
      'hustensaft kinder',
    ],
  },
  {
    query: 'halsschmerzen',
    suggestions: ['spray', 'kinder', 'tabletten', 'lutschtabletten'],
  },
  {
    query: 'B12',
    suggestions: [
      'ankermann',
      'ampullen',
      'vita',
      ' ankermann tabletten',
      'tropfen',
    ],
  },
  {
    query: 'dermasence',
    suggestions: ['rosamin', 'seborra', 'aha', 'adtop', 'hyalusome'],
  },
]
